var swiper = new Swiper(".mySwiper", {
    spaceBetween: 12,
    slidesPerView: 2.3,
    freeMode: true,
    watchSlidesProgress: true,
    navigation: {
        nextEl: ".custom-slider-next",
        prevEl: ".custom-slider-prev",
    },
    breakpoints: {
        992: {
          slidesPerView: 3,
          spaceBetween: 12,
        },
      },
  });
  var swiper2 = new Swiper(".mySwiper2", {
    spaceBetween: 10,
    thumbs: {
      swiper: swiper,
    },
  });
Fancybox.bind('[data-fancybox="gallery"]', {
  //
});   